/**
 * Banner 6000 — BDU auxiliary page hero.
 *
 * A single static background with a left gradient card (title + accreditation
 * bar). Unlike Banner 1025 there is no carousel, so the badges take the primary
 * `metadata` group instead of `metadata_1`.
 */

export const BANNER_6000_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Accreditation badges",
  },

  DEFAULT_ROW: {
    id: "1",
    image: "",
    alt_image: "",
    priority: 1,
    status: true,
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "image",
      label: "Background image (desktop)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload the hero background",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "mobile_image",
      label: "Background image (mobile)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Optional — falls back to the desktop image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "image_alt",
      label: "Background image alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. Student Support Services",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_color",
      label: "Title color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "hero_section_height",
      label: "Hero height — desktop (px)",
      value: 418,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "418",
      description: "Mobile height is fixed at 402px, as in the reference.",
      required: false,
      defaultValue: 418,
    },
    {
      fieldName: "background_color",
      label: "Overlay color (mobile)",
      value: "#22405ADB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#22405ADB",
      description: "Solid overlay below 768px. Supports 8-digit hex for alpha.",
      required: false,
      defaultValue: "#22405ADB",
    },
    {
      fieldName: "gradient_color_1",
      label: "Overlay gradient — start",
      value: "#13344F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#13344F",
      description: "Left-to-right gradient on the overlay card from 768px up.",
      required: false,
      defaultValue: "#13344F",
    },
    {
      fieldName: "gradient_color_2",
      label: "Overlay gradient — end",
      value: "#77B6EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#77B6EB",
      required: false,
      defaultValue: "#77B6EB",
    },
    {
      fieldName: "carousel_color",
      label: "Accreditation strip background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "status",
      label: "Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable section",
      required: false,
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Badge image",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload accreditation badge",
      defaultValue: "",
    },
    {
      header: "Badge alt",
      fieldName: "alt_image",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "e.g. NAAC GRADE A",
      defaultValue: "",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Show this badge",
      defaultValue: true,
    },
  ],
};
